module.exports = __webpack_public_path__ + "static/media/business_1.5f514fa9.png";